import React from 'react'
import PropTypes from 'prop-types'
import { gridSizesClassName } from '../utils/gridSizes'

export default function FixedBarComponent(props) {

  return (
    <div>
      <div>{props.children}</div>
      <div className={`${props.active ? 'is-active' : ''}`}>
        {props.onClose && <a className="r-fixed-bar__content-close" onClick={props.onClose}><i className="fas fa-times-circle"></i></a>}
        {props.active && props.renderContent()}
      </div>
    </div>
  )
}

FixedBarComponent.propTypes = {
  active: PropTypes.bool,
  renderContent: PropTypes.func,
  onClose: PropTypes.func
}

FixedBarComponent.defaultProps = {

}
